import { render, staticRenderFns } from "./SetariPreturiMateriePrima.vue?vue&type=template&id=ca3facea&scoped=true"
import script from "./SetariPreturiMateriePrima.vue?vue&type=script&lang=js"
export * from "./SetariPreturiMateriePrima.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3facea",
  null
  
)

export default component.exports